import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DropDownInputField from "../../components/forms/DropDownInputField";
import FormError from "../../components/forms/FormError";

class AssignAccountVipStatusForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>Assigning VIP status to an account will give the account similar qualities to a subscriber. The prices for one-time products will be the same as the price for a subscription.</p>
          <FormFieldsTable>
            <Field 
              label="Pricelist Version"
              name="pricelistVersion"
              component={DropDownInputField}
              data={this.props.versions}
              valueKey="version"  
              titleKey="label" 
              showBlank={false}
              serverError={this.props.errors.pricelistVersion}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AssignAccountVipStatusForm"
})(AssignAccountVipStatusForm);

export default ReduxForm;